module.exports = __webpack_public_path__ + "static/media/shutterstock_1654284619.2e609494.jpg";